import React from 'react';
import { Select } from '@mui/base/Select';


const AcaSelect = (props) => {
    const { 
        children = null,
        extraClasses = '',
        ...restProps 
    } = props;



    return (
        <div className="acaSelect__wrapper">
            <Select className={"acaSelect " + extraClasses} {...restProps} slotProps={{ popup: { className: 'acaDropdown', disablePortal: true } }}>
                {children}
            </Select>
        </div>
    );

}



/**
 * Export
 */
export { AcaSelect };